import { Component, Input } from '@angular/core';
import { SiteAmenityModel } from 'src/app/models/SiteDetails/SiteAmenityModel';
import { AmenitiesIconsMap } from 'src/app/models/app-constants';

@Component({
	selector: 'app-site-amenity',
	templateUrl: './site-amenity.component.html',
	styleUrls: ['./site-amenity.component.scss']
})
export class SiteAmenityComponent {
	@Input() amenity: SiteAmenityModel;

	get imageName() {
		return AmenitiesIconsMap.get(this.amenity?.Name);
	}
}
